<div class="grid-container margin-top">
  <!-- not read only -->
  @if (record && !record.haveGeneratedLabel) {
    <div>
      @if (!editingLetter) {
        @if (pdfLoaded) {
           <ngx-extended-pdf-viewer [src]="pdfSrc" [scrollMode]="1" [pageViewMode]="'infinite-scroll'" [showToolbar]="false" ></ngx-extended-pdf-viewer>
        }
        @if (!pdfLoaded) {
          <div class="bold"> Generating Preview.... please wait... </div>
        }
      }
      @if (editingLetter) {
        <div [formGroup]="letterContentsForm">
          <div formControlName="updatedContents" id="updatedContents" name="updatedContents" [froalaEditor]="froalaOptions" [(ngModel)]="htmlContent"> </div>
        </div>
      }
      <div class="grid-x grid-margin-x padding-bottom-large section margin-top">
        <div class="cell medium-12 text-center">
          <button class="button text-right margin-right" (click)="toggleLetterEditing()" [disabled]="!htmlContentFetched">{{letterEditButtonText}}</button>
          <button class="button text-right margin-right" (click)="saveLetterConfirmation()" [disabled]="!letterDetailsForm.valid">Save Letter</button>
        </div>
      </div>
      <form [formGroup]="letterDetailsForm" class="grid-x grid-margin-x">
        <div class="cell small-12">
          <ng-container>
            <label for="mailDeliveryType">*Mail Delivery Type:</label>
            <select id="mailDeliveryType" (change)="mailDeliveryTypeChanged($event)" formControlName="mailDeliveryType">
              @for (option of mailDeliveryOptions(); track option) {
                <option [value]="option.value">{{option.displayText}}</option>
              }
            </select>
            @if (letterDetailsForm.controls['mailDeliveryType'].invalid && (letterDetailsForm.controls['mailDeliveryType'].dirty || letterDetailsForm.controls['mailDeliveryType'].touched)) {
              <div class="error-container">
                @if (letterDetailsForm.get('mailDeliveryType').hasError('required')) {
                  <small class="error">
                    A mail delivery type is required
                  </small>
                }
              </div>
            }
            @if (letterDetailsForm.controls['mailDeliveryType'].value == 'Other') {
              <div class="cell small-12 medium-6">
                <label class="required">
                  Reason for choosing other:
                  <input type="text" formControlName="otherReason" />
                </label>
                @if ((letterDetailsForm.controls['otherReason'].value === null || letterDetailsForm.controls['otherReason'].value === '' ) && (letterDetailsForm.controls['organizationName'].dirty || letterDetailsForm.controls['organizationName'].touched)) {
                  <div class="error-container">
                    @if (letterDetailsForm.get('organizationName').hasError('required')) {
                      <small class="error">
                        If choosing the Other delivery method, a reason must be provided
                      </small>
                    }
                  </div>
                }
                <label>
                  Tracking Number:
                  <input type="text" formControlName="otherTrackingNumber" />
                </label>
              </div>
            }
          </ng-container>
        </div>
        <div class="cell small-12 margin-bottom">
          <span class="bold">PDF Page Count: {{record.pageCount}}</span>
        </div>
        <div class="cell small-12 medium-3">
          <label id="additionalPages">
            Number of Additional Pages/Attachments <help-text [helpText]="pagesHelpText"></help-text>:
            <input type="number" min="0" aria-labelledby="additionalPages" (input)="checkLabelSizeOptions()" formControlName="pageCount" />
          </label>
        </div>
        <div class="cell small-12 medium-6">
          <label id="envelopeType">
            <br />Label Type:
            <select aria-labelledby="envelopeType" #envelopeType formControlName="labelSize">
              <option value="0">#10 Envelope</option>
              <option value="1">9X12 Envelope</option>
            </select>
          </label>
        </div>
        <div class="cell small-12 medium-3">
          <label><br />Sent Date:</label>
          <common-date-picker #sentDatePicker [id]="'fromDate'" (dateUpdated)="sentDateChanged($event)" [initialDate]="sentDate" [daysPast]="daysPast" [daysFuture]="daysFuture"></common-date-picker>
        </div>
        <div class="cell small-12">
          @if (offices) {
            <label for="originatingOffice">*Originating Office:</label>
            <select id="originatingOffice" formControlName="originatingOffice">
              @for (option of offices; track option) {
                <option [value]="option.title">{{option.title}}</option>
              }
            </select>
            @if (letterDetailsForm.controls['originatingOffice'].invalid && (letterDetailsForm.controls['originatingOffice'].dirty || letterDetailsForm.controls['originatingOffice'].touched)) {
              <div class="error-container">
                @if (letterDetailsForm.get('originatingOffice').hasError('required')) {
                  <small class="error">
                    Originating Office
                    is required
                  </small>
                }
              </div>
            }
          }
        </div>
        <div class="cell small-12">
          <div class="grid-x grid-margin-x">
            <div class="cell small-12 medium-12">
              <label class="required">
                Recipient Name:
                <input type="text" formControlName="recipientName1" />
              </label>
              @if (letterDetailsForm.controls['recipientName1'].invalid && (letterDetailsForm.controls['recipientName1'].value === null || letterDetailsForm.controls['recipientName1'].value === '')  && (letterDetailsForm.controls['recipientName1'].dirty || letterDetailsForm.controls['recipientName1'].touched)) {
                <div class="error-container">
                  @if (letterDetailsForm.get('recipientName1').hasError('required')) {
                    <small class="error">
                      Recipient
                      name is required
                    </small>
                  }
                </div>
              }
            </div>
            <div class="cell small-12 medium-6">
              <label class="required">
                Organization Name:
                <input type="text" formControlName="organizationName" />
              </label>
              @if (letterDetailsForm.controls['organizationName'].invalid && (letterDetailsForm.controls['organizationName'].value === null || letterDetailsForm.controls['organizationName'].value === '' ) && (letterDetailsForm.controls['organizationName'].dirty || letterDetailsForm.controls['organizationName'].touched)) {
                <div class="error-container">
                  @if (letterDetailsForm.get('organizationName').hasError('required')) {
                    <small class="error">
                      Organization name
                      is required
                    </small>
                  }
                </div>
              }
            </div>
            <div class="cell small-12 medium-6">
              <label class="required">
                Organization RICS Number:
                <input type="text" formControlName="organizationId" />
              </label>
              @if (letterDetailsForm.controls['organizationId'].invalid && (letterDetailsForm.controls['organizationId'].value === null || letterDetailsForm.controls['organizationId'].value === '' ) && (letterDetailsForm.controls['organizationId'].dirty || letterDetailsForm.controls['organizationId'].touched)) {
                <div class="error-container">
                  @if (letterDetailsForm.get('organizationId').hasError('required')) {
                    <small class="error">
                      Organization RICS Number
                      is required
                    </small>
                  }
                </div>
              }
            </div>
            <div class="cell small-12">
              <label class="required">
                Address1:
                <input type="text" formControlName="address1" />
              </label>
              @if (letterDetailsForm.controls['address1'].invalid && (letterDetailsForm.controls['address1'].value === null || letterDetailsForm.controls['address1'].value === '') && (letterDetailsForm.controls['address1'].dirty || letterDetailsForm.controls['address1'].touched)) {
                <div class="error-container">
                  @if (letterDetailsForm.get('address1').hasError('required')) {
                    <small class="error">
                      Address
                      is required
                    </small>
                  }
                </div>
              }
            </div>
            <div class="cell small-12">
              <label>
                Address2:
                <input type="text" formControlName="address2" />
              </label>
            </div>
            <div class="cell small-12 medium-4">
              <label class="required">
                City:
                <input type="text" formControlName="city" />
              </label>
              @if (letterDetailsForm.controls['city'].invalid && (letterDetailsForm.controls['city'].value === null || letterDetailsForm.controls['city'].value === '') && (letterDetailsForm.controls['city'].dirty || letterDetailsForm.controls['city'].touched)) {
                <div class="error-container">
                  @if (letterDetailsForm.get('city').hasError('required')) {
                    <small class="error">
                      City is required
                    </small>
                  }
                </div>
              }
            </div>
            <div class="cell small-12 medium-2">
              <label class="required">
                State:
                <input type="text" formControlName="state" />
              </label>
              @if (letterDetailsForm.controls['state'].invalid && (letterDetailsForm.controls['state'].value === null || letterDetailsForm.controls['state'].value === '') && (letterDetailsForm.controls['state'].dirty || letterDetailsForm.controls['state'].touched)) {
                <div class="error-container">
                  @if (letterDetailsForm.get('state').hasError('required')) {
                    <small class="error">
                      State is required
                    </small>
                  }
                </div>
              }
            </div>
            <div class="cell small-12 medium-3">
              <label class="required">
                ZipCode:
                <input type="text" formControlName="zipCode" />
              </label>
              @if (letterDetailsForm.controls['zipCode'].invalid && (letterDetailsForm.controls['zipCode'].value === null || letterDetailsForm.controls['zipCode'].value === '') && (letterDetailsForm.controls['zipCode'].dirty || letterDetailsForm.controls['zipCode'].touched)) {
                <div class="error-container">
                  @if (letterDetailsForm.get('zipCode').hasError('required')) {
                    <small class="error">
                      Zipcode is required
                    </small>
                  }
                </div>
              }
            </div>
            <div class="cell small-12 medium-3">
              <label>
                Zip + 4:
                <input type="text" formControlName="zipPlus4" maxlength="4" />
              </label>
            </div>
          </div>
        </div>
        @if (letterDetailsForm.controls['mailDeliveryType'].value == 'Certified') {
          <div class="cell small-12">
            <label id="referenceLine">
              Reference Line:
              <input type="text" aria-labelledby="referenceLine" formControlName="refLine" />
            </label>
          </div>
        }
        @if (letterDetailsForm.controls['mailDeliveryType'].value == 'Certified') {
          <div class="cell small-3 medium-3 flex-item v-align">
            <input class="no-margin vertical-align-middle" type="checkbox" id="restrictDelivery" formControlName="restrictDelivery">
            <label class="display-inline-block" for="restrictDelivery">Restricted Delivery</label>
          </div>
        }
        @if (letterDetailsForm.controls['mailDeliveryType'].value == 'Certified') {
          <div class="cell small-3 medium-3 flex-item v-align">
            <input class="no-margin vertical-align-middle" type="checkbox" id="trackRRE" formControlName="trackRre">
            <label class="display-inline-block" for="trackRRE">Track RRE</label>
          </div>
        }
        @if (letterDetailsForm.controls['mailDeliveryType'].value == 'Certified') {
          <div class="cell small-3 medium-3 flex-item v-align">
            <input class="no-margin vertical-align-middle" type="checkbox" id="notifySender" formControlName="notifySender" (change)="changeText($event.target.checked)">
            <label class="display-inline-block" for="notifySender">Notify Sender</label>
          </div>
        }
        @if (letterDetailsForm.controls['mailDeliveryType'].value == 'Certified') {
          <div class="cell small-12 medium-3">
            @if (record.notifySender) {
              <label id="senderEmail">
                {{labelSenderEmail}}
                <input type="text" aria-labelledby="senderEmail" formControlName="notificationEmail" />
              </label>
            }
            @if ((letterDetailsForm.controls['notificationEmail'].invalid && (letterDetailsForm.controls['notificationEmail'].dirty || letterDetailsForm.controls['notificationEmail'].touched))) {
              <div class="error-container">
                @if (letterDetailsForm.get('notificationEmail').hasError('required')) {
                  <small class="error">
                    Email
                    Address is required
                  </small>
                }
                @if (letterDetailsForm.get('notificationEmail').hasError('pattern')) {
                  <small class="error">
                    Email
                    is invalid
                  </small>
                }
              </div>
            }
          </div>
        }
        @if (letterDetailsForm.controls['mailDeliveryType'].value == 'HandDelivery') {
          <div class="cell small-12 medium-3">
            <div class="cell small-12 medium-3">
              <label><br />Delivered Date:</label>
              <common-date-picker #deliveryDatePicker [id]="'deliveryDate'" (dateUpdated)="deliveryDateChanged($event)" [initialDate]="deliveryDate" [daysPast]="deliveredDaysPast" [daysFuture]="deliveredDaysFuture"></common-date-picker>
            </div>
          </div>
        }
      </form>
      @if (displayFileUploads()) {
        @if (!attachmentsFetched) {
          <div>
            Checking for prior uploads .... please wait...
          </div>
        }
        @if (attachmentsFetched) {
          <div>
            <div class="grid-x grid-margin-x padding-bottom-large section">
              <div class="cell large-12 bold">
                Upload Delivery Method supporting file(s):
              </div>
              <div class="cell large-12">
                <upload-view-files [uniqueId]="'uploader'" [files]="_displayedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="true" (fileRemoved)="onFileDeleted($event)" (newFilesList)="fileAdded($event)">
                </upload-view-files>
              </div>
              <div class="cell large-12 bold">
                *These files will not persist unless you save the letter.
              </div>
            </div>
          </div>
        }
      }
      <div class="grid-x grid-margin-x padding-bottom-large section margin-top">
        <div class="cell medium-6 text-left">
          <button (click)="generateLabel()" class="button" [disabled]="!letterDetailsForm.valid">Generate Label</button>
        </div>
      </div>
      <div class="cell small-12">
        <div>
          *If sending certified, to have the generated tracking number inserted into the letter, please have the following text (including the brackets) <span class="bold" [ngClass]="'red'">[mailNumber]</span> somewhere in the letter content.
          That will be replaced with the new tracking number once it is received from Simple Certified.
          <br />
        </div>
      </div>
    </div>
  }

  <!-- read only -->
  @if (record && record.haveGeneratedLabel) {
    <div>
      <div class="grid-x grid-margin-x">
        <div class="cell small-12">
          {{record.title}}
        </div>
      </div>
      @if (displayFileUploads()) {
        @if (!attachmentsFetched) {
          <div>
            Checking for prior uploads .... please wait...
          </div>
        }
        @if (attachmentsFetched) {
          <div>
            <div class="grid-x grid-margin-x padding-bottom-large section">
              <div class="cell large-12 bold">
                Uploaded Delivery Method supporting file(s): <span class="bold" [ngClass]="{ 'red': letterDetailsForm?.get('uploadedFiles')?.invalid }">*</span>
              </div>
              <div class="cell large-12">
                <upload-view-files [uniqueId]="'uploader'" [allowUpload]="false" [allowDeletion]="false" [files]="_displayedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true"(fileRemoved)="onFileDeleted($event)" (newFilesList)="fileAdded($event)">
                </upload-view-files>
              </div>
            </div>
          </div>
        }
      }
      <!-- as seen after the address in https://cloud.indigo.design/share/run/x96q8u9rj5me?open_toc=false#f=dashboard-mailer&s=3835ce -->
      <div class="grid-x grid-margin-x">
        @if (record.referenceLine) {
          <div class="cell small-12">
            Reference Line: {{record.referenceLine}}
          </div>
        }
      </div>
      <!-- as seen at the bottom of https://cloud.indigo.design/share/run/x96q8u9rj5me?open_toc=false#f=dashboard-mailer&s=af88af -->
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 text-right margin-top">
          <button (click)="downloadLetter()" class="button">Download Letter</button>
          <a style="display:none" #letterDownloadLink></a>
          <button (click)="downloadLabel()" class="button">Download Label</button>
          <a style="display:none" #labelDownloadLink></a>
        </div>
      </div>
      <!-- as seen at the top of https://cloud.indigo.design/share/run/x96q8u9rj5me?open_toc=false#f=dashboard-mailer&s=68dab9 -->
      @if (record.isCertified) {
        <div class="grid-x grid-margin-x">
          <div class="cell small-12 medium-shrink">
            <button class="button hollow" (click)="checkForUpdatedStatus()">Check for Updated Status</button>
          </div>
          @if (record.haveDeliveryDocument) {
            <div class="cell small-12 medium-shrink">
              <button class="button hollow" (click)="downloadDelivery()">View Delivery</button>
              <a style="display:none" #deliveryDownloadLink></a>
            </div>
          }
          @if (record.haveAcceptanceDocument) {
            <div class="cell small-12 medium-shrink">
              <button class="button hollow" (click)="downloadAcceptance()">View Acceptance</button>
              <a style="display:none" #acceptanceDownloadLink></a>
            </div>
          }
          @if (record.haveSignatureDocument) {
            <div class="cell small-12 medium-shrink">
              <button class="button hollow" (click)="downloadSignature()">View Signature</button>
              <a style="display:none" #signatureDownloadLink></a>
            </div>
          }
        </div>
      }
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-auto text-right">
          <button class="button" (click)="regenerate()">Resend Letter</button>
        </div>
        @if (_record.mailType == Other) {
          <div class="cell small-12 medium-6">
            <span class="bold">Mailing Type:</span> {{record.mailType}}
          </div>
        }
        @if (_record.mailType == Other) {
          <div class="cell small-12 medium-6">
            <span class="bold">Reason:</span> {{record.otherReason}}
          </div>
        }
        @if (_record.mailType != Other) {
          <div class="cell small-12 medium-12">
            <span class="bold">Mailing Type:</span> {{record.mailType}}
          </div>
        }
        <div class="cell small-12 medium-6">
          <span class="bold">Mailing Sent:</span> {{record.sentDate | date}}
        </div>
        <div class="cell small-12 medium-6">
          <span class="bold">Mailing Delivered:</span> {{record.deliveryDate | date}}
        </div>
        <div class="cell small-12 medium-6">
          <span class="bold">Status:</span> {{letterStatusName}}
        </div>
        @if (record.isCertified) {
          <div class="cell small-12 medium-6">
            <span class="bold">Tracking #:</span> {{record.trackingNumber}}
          </div>
        }
		  <div class="cell small-12 margin-top">
			  @if (pdfLoaded) {
			  <ngx-extended-pdf-viewer [src]="pdfSrc"
								 [textLayer]="true"
								 [showAll]="true"
								 [page]="currentPage"
                 [pageViewMode]="'infinite-scroll'"
								 [showToolbar]="false">
			  </ngx-extended-pdf-viewer>
			  }
			  @if (!pdfLoaded) {
			  Retrieving Letter.... please wait...
			  }
		  </div>
      </div>
    </div>
  }
</div>